function initialState() {
  return {
    notifications: [],
  }
}

let state = initialState()

export {
  initialState,
  state
}
